function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import T from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { PRODUCT_TYPE } from '../../constants/product';
import text from '../../text';
import { IconButton } from '../button';
import Container from '../containers/Container';
import Loading from '../loading/Loading';
import { MapViewContext } from '../mapView/mapViewContext';
import ProductTooltip from '../mapView/productTooltip/ProductTooltip';
import useGeocoder from './useGeocoder';
import useSmartSelections from './useSmartSelections';
var SMART_SELECTIONS_HEADING = {
    manual: text('getQuote3dScanCaptureServices'),
    automatic: text('buyNow3dDataInDatabase')
};
var SMART_SELECTIONS_DETAILS = {
    manual: text('getQuote3dScanCaptureServicesDetails'),
    automatic: text('buyNow3dDataInDatabaseDetails')
};
// eslint-disable-next-line react/prop-types
var SmartSelectionsButton = function(param) {
    var show = param.show, deliveryType = param.deliveryType, isReadOnly = param.isReadOnly, _param_buttonId = param.buttonId, buttonId = _param_buttonId === void 0 ? null : _param_buttonId;
    var state = useContext(MapViewContext).state;
    var mapState = useSelector(function(reduxState) {
        return {
            mapState: reduxState.mapReducer
        };
    }).mapState;
    var _useGeocoder = useGeocoder(), geocode = _useGeocoder.geocode, geocodeReady = _useGeocoder.geocodeReady;
    var addSmartSelectionsInPlace = useSmartSelections();
    var handleClick = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _state_job, place;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isReadOnly) {
                        console.warn('tried to add smart selections on read-only order');
                        return [
                            2
                        ];
                    }
                    if (!((_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.full_address)) {
                        console.error('tried to add smart selections with no job or job address');
                        return [
                            2
                        ];
                    }
                    if (!geocodeReady) {
                        console.error('tried to add smart selections without geocoder ready');
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        geocode(state.job.full_address)
                    ];
                case 1:
                    place = _state.sent();
                    return [
                        4,
                        addSmartSelectionsInPlace({
                            address: state.job.address,
                            city: state.job.city,
                            state: state.job.state,
                            postcode: state.job.postcode,
                            location: {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng()
                            }
                        }, deliveryType, buttonId)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        state.job,
        geocodeReady
    ]);
    if (!show) {
        return null;
    }
    var isLoading = mapState.isLoadingSmartSelections && mapState.smartSelectionsDeliveryMethod === deliveryType;
    return isReadOnly ? null : /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: handleClick,
        disabled: isLoading,
        className: "cta-button position-relative"
    }, /*#__PURE__*/ React.createElement(Container, {
        noBorder: true,
        isSecondary: true,
        className: classNames('d-flex justify-content-between p-3 align-items-center', {
            'is-readonly': isReadOnly
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row align-items-center"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "font-weight-bold m-0 mr-2"
    }, SMART_SELECTIONS_HEADING[deliveryType]), /*#__PURE__*/ React.createElement(ProductTooltip, {
        productType: deliveryType === 'manual' ? PRODUCT_TYPE.ADDON_SCAN : PRODUCT_TYPE.ADDON_DATABASE,
        placement: "top"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "m-0",
        style: {
            fontSize: '12px'
        }
    }, SMART_SELECTIONS_DETAILS[deliveryType])), /*#__PURE__*/ React.createElement("div", {
        className: classNames('d-flex flex-column add-button-container', {
            'read-only': isReadOnly
        })
    }, /*#__PURE__*/ React.createElement(IconButton, {
        iconProps: {
            isOriginal: true
        },
        icon: isReadOnly ? 'plus-filled-grey' : 'plus-filled'
    }), /*#__PURE__*/ React.createElement("p", {
        className: classNames('m-0 font-weight-bold', {
            'green-1': !isReadOnly,
            'grey-3': isReadOnly
        })
    }, text('add'))), mapState.isLoadingSmartSelections && mapState.loadingRhsButtonIds.includes(buttonId) ? /*#__PURE__*/ React.createElement("div", {
        className: "loader-container"
    }, /*#__PURE__*/ React.createElement(Loading, null)) : null));
};
SmartSelectionsButton.propTypes = {
    show: T.bool,
    deliveryType: T.oneOf([
        'manual',
        'automatic'
    ]).isRequired,
    isReadOnly: T.bool,
    buttonId: T.string
};
SmartSelectionsButton.defaultProps = {
    show: false
};
export default SmartSelectionsButton;
